import { cn } from "@/utils/functions";
import {
  BarChartOutlined,
  CodeSandboxOutlined,
  FileDoneOutlined,
  FileOutlined,
  FileSyncOutlined,
  FundProjectionScreenOutlined,
  SettingOutlined,
  UnorderedListOutlined,
  WalletOutlined,
  DashboardOutlined,
  SolutionOutlined,
  NotificationOutlined,
} from "@ant-design/icons";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import { IoDocumentTextOutline, IoTicketOutline } from "react-icons/io5";
import { MdEmail, MdOutlinePermMedia } from "react-icons/md";
import { RiBillLine, RiContactsLine } from "react-icons/ri";
import { useSelector } from "react-redux";
import { NavLink } from "react-router-dom";
import Menu from "../../UI/Menu";
import usePermissions from "../../utils/usePermissions";

import { BiBuildingHouse } from "react-icons/bi";
import { FiShoppingCart, FiUsers } from "react-icons/fi";
import { GoTasklist } from "react-icons/go";
import { HiOutlineLightBulb } from "react-icons/hi";
import { LuLink, LuClipboardEdit, LuGraduationCap } from "react-icons/lu";
import { useLanguage } from "../../contexts/LanguageContext";
import useSettingNav from "./SettingNav";
import SideNavLoader from "./SideNavLoader";

const SideNav = ({ collapsed, setCollapsed }) => {
  const { t } = useTranslation();
  const { isRTL } = useLanguage();
  const { permissions } = usePermissions();
  const [active, setActive] = useState({
    isSetting: false,
    isCrm: false,
  });
  const { loading } = useSelector((state) => state.auth);

  const menu = [
    {
      label: (
        <NavLink to="/admin/dashboard">
          <span>{t("navigation.dashboard")}</span>
        </NavLink>
      ),
      key: "dashboard",
      icon: <DashboardOutlined />,
    },
    {
      label: (
        <NavLink to="/admin/analytics">
          <span>{t("navigation.analytics") || "Analytics"}</span>
        </NavLink>
      ),
      permit: {
        permissions: ["create-deal", "readAll-deal"],
        operator: "or",
      },
      key: "ANALYTICS",
      icon: <BarChartOutlined />
    },

    {
      label: (
        <NavLink to="/admin/lead">
          <span>{t("navigation.leads")}</span>
        </NavLink>
      ),
      permit: {
        permissions: ["create-Lead", "readAll-lead", "readSingle-lead"],
        operator: "or",
      },
      key: "lead",
      icon: <FiUsers size={16} />,
    },

    {
      label: (
        <NavLink to="/admin/contact">
          <span>{t("navigation.contact")}</span>
        </NavLink>
      ),
      permit: {
        permissions: ["create-contact", "readAll-contact", "readRole-contact", "readSingle-contact"],
        operator: "or",
      },
      key: "CONTACT",
      icon: <RiContactsLine />,
    },
    {
      label: (
        <NavLink to="/admin/company">
          <span>{t("navigation.company")}</span>
        </NavLink>
      ),
      permit: {
        permissions: [
          "create-company",
          "readAll-company",
          "readSingle-company",
          "create-agent",
          "readAll-agent",
          "readSingle-agent",
        ],
        operator: "or",
      },
      key: "COMPANY",
      icon: <BiBuildingHouse />,
    },
    {
      label: (
        <NavLink to="/admin/crm/university">
          <span>{t("navigation.university") || "Universities"}</span>
        </NavLink>
      ),
      permit: {
        permissions: ["create-university", "readAll-university"],
        operator: "or",
      },
      key: "UNIVERSITY",
      icon: <LuGraduationCap size={16} />,
    },
    {
      label: (
        <NavLink to="/admin/major">
          <span>{t("navigation.major") || "Majors"}</span>
        </NavLink>
      ),
      permit: {
        permissions: ["create-major", "readAll-major"],
        operator: "or",
      },
      key: "MAJOR",
      icon: <UnorderedListOutlined size={16} />,
    },
    {
      label: (
        <NavLink to="/admin/application">
          <span>{t("navigation.application")}</span>
        </NavLink>
      ),
      permit: {
        permissions: ["create-application", "readAll-application", "readSingle-application"],
        operator: "or",
      },
      key: "APPLICATION",
      icon: <SolutionOutlined />,
    },

    /* {
      label: (
        <NavLink to="/admin/product">
          <span>{t("navigation.product")}</span>
        </NavLink>
      ),
      key: "products",
      permit: {
        permissions: ["create-product", "readAll-product"],
        operator: "or",
      },
      icon: <CodeSandboxOutlined />,
    }, */

    /* {
      label: t("navigation.sales"),
      key: "sale",
      permit: {
        permissions: [
          "create-saleInvoice",
          "readAll-saleInvoice",
          "readAll-quote",
          "create-quote",
        ],
        operator: "or",
      },
      icon: <FiShoppingCart />,
      children: [
        {
          label: (
            <NavLink to="/admin/quote">
              <span>{t("navigation.quote")}</span>
            </NavLink>
          ),
          permit: {
            permissions: ["create-quote", "readAll-quote"],
            operator: "or",
          },
          key: "QUOTE",
          icon: <RiBillLine />,
        },
        {
          label: (
            <NavLink to="/admin/sale-invoice">
              <span>{t("navigation.invoice")}</span>
            </NavLink>
          ),
          permit: {
            permissions: ["create-saleInvoice", "readAll-saleInvoice"],
            operator: "or",
          },
          key: "invoice",
          icon: <UnorderedListOutlined />,
        },
      ],
    }, */

    /* {
      label: (
        <NavLink to="/admin/opportunity">
          <span>{t("navigation.opportunity")}</span>
        </NavLink>
      ),
      permit: {
        permissions: ["create-opportunity", "readAll-opportunity"],
        operator: "or",
      },
      key: "OPPORTUNITY",
      icon: <HiOutlineLightBulb />,
    }, */
    {
      label: (
        <NavLink to="/admin/deal">
          <span>{t("navigation.deal") || "Deals"}</span>
        </NavLink>
      ),
      permit: {
        permissions: ["create-deal", "readAll-deal", "readSingle-deal"],
        operator: "or",
      },
      key: "DEAL",
      icon: <HiOutlineLightBulb size={16} />,
    },

    {
      label: (
        <NavLink to="/admin/task">
          <span>{t("navigation.task")}</span>
        </NavLink>
      ),
      key: "TASK",
      icon: <GoTasklist />,
    },
    /* {
      label: t("navigation.project"),
      key: "project",
      icon: <SettingOutlined />,
      permit: {
        permissions: [
          "create-project",
          "readAll-project",
          "create-team",
          "readAll-team",
        ],
        operator: "or",
      },
      children: [
        {
          label: (
            <NavLink to="/admin/project">
              <span>{t("navigation.project")}</span>
            </NavLink>
          ),
          permit: {
            permissions: ["create-project", "readAll-project"],
            operator: "or",
          },
          key: "project",
          icon: <SettingOutlined />,
        },
        {
          label: (
            <NavLink to="/admin/team">
              <span>{t("navigation.team")}</span>
            </NavLink>
          ),
          permit: {
            permissions: ["create-team", "readAll-team"],
            operator: "or",
          },
          key: "team",
          icon: <SettingOutlined />,
        },
      ],
    }, */
    /* {
      label: t("navigation.accounts"),
      permit: {
        permissions: [
          "create-account",
          "readAll-account",
          "create-transaction",
          "readAll-transaction",
        ],
        operator: "or",
      },
      key: "accounts",
      icon: <WalletOutlined />,
      children: [
        {
          label: (
            <NavLink to="/admin/account/">
              <span>{t("navigation.account")}</span>
            </NavLink>
          ),
          permit: {
            permissions: ["create-account", "readAll-account"],
            operator: "or",
          },
          key: "accountList",
          icon: <UnorderedListOutlined />,
        },
        {
          label: (
            <NavLink to="/admin/transaction/">
              <span>{t("navigation.transaction")}</span>
            </NavLink>
          ),
          permit: {
            permissions: ["create-transaction", "readAll-transaction"],
            operator: "or",
          },
          key: "transactionList",
          icon: <UnorderedListOutlined />,
        },
      ],
    }, */
    {
      label: t("navigation.report"),
      key: "report",
      icon: <IoDocumentTextOutline size={16} />,
      permit: {
        permissions: ["create-report", "readAll-report"],
        operator: "or",
      },
      children: [
        {
          label: (
            <NavLink to="/admin/account/trial-balance">
              <span>{t("navigation.trialBalance")}</span>
            </NavLink>
          ),
          key: "trialBalance",
          icon: <FileDoneOutlined />,
        },
        {
          label: (
            <NavLink to="/admin/account/balance-sheet">
              <span>{t("navigation.balanceSheet")}</span>
            </NavLink>
          ),
          key: "balanceSheet",
          icon: <FileOutlined />,
        },
        {
          label: (
            <NavLink to="/admin/account/income">
              <span>{t("navigation.incomeStatement")}</span>
            </NavLink>
          ),
          key: "incomeStatement",
          icon: <FileSyncOutlined />,
        },
      ],
    },

    /* {
      label: (
        <NavLink to="/admin/media">
          <span>{t("navigation.media")}</span>
        </NavLink>
      ),
      permit: {
        permissions: ["create-media", "readAll-media"],
        operator: "or",
      },
      key: "media",
      icon: <MdOutlinePermMedia />,
    }, */

    // CRM

    {
      label: (
        <NavLink to="/admin/note">
          <span>{t("navigation.note")}</span>
        </NavLink>
      ),
      permit: {
        permissions: ["create-note", "readAll-note"],
        operator: "or",
      },
      key: "NOTE",
      icon: <LuClipboardEdit size={15} />,
    },
    {
      label: (
        <NavLink to="/admin/announcement">
          <span>{t("navigation.announcement")}</span>
        </NavLink>
      ),
      permit: {
        permissions: ["readAll-announcement", "create-announcement"],
        operator: "or",
      },
      key: "announcement",
      icon: <NotificationOutlined />,
    },

    /* {
      label: t("navigation.others"),
      key: "other",
      permit: {
        permissions: [
          "create-note",
          "readAll-note",
          "create-email",
          "readAll-email",
          "create-attachment",
          "readAll-attachment",
        ],
        operator: "or",
      },
      icon: <CodeSandboxOutlined />,
      children: [
        {
          label: (
            <NavLink to="/admin/note">
              <span>{t("navigation.note")}</span>
            </NavLink>
          ),
          permit: {
            permissions: ["create-note", "readAll-note"],
            operator: "or",
          },
          key: "NOTE",
          icon: <TiContacts />,
        },
        {
          label: (
            <NavLink to="/admin/attachment">
              <span>{t("navigation.attachment")}</span>
            </NavLink>
          ),
          permit: {
            permissions: ["create-attachment", "readAll-attachment"],
            operator: "or",
          },
          key: "ATTACHMENT",
          icon: <LuLink />,
        },
        {
          label: (
            <NavLink to="/admin/email">
              <span>{t("navigation.email")}</span>
            </NavLink>
          ),
          permit: {
            permissions: ["create-email", "readAll-email"],
            operator: "or",
          },
          key: "EMAIL",
          icon: <MdEmail />,
        },
      ],
    }, */
    /* {
      label: (
        <NavLink to="/admin/ticket">
          <span>{t("navigation.ticket")}</span>
        </NavLink>
      ),
      permit: {
        permissions: ["create-ticket", "readAll-ticket"],
        operator: "or",
      },
      key: "TICKET",
      icon: <IoTicketOutline />,
    }, */
  ];

  const SettingMenu = useSettingNav();

  return (
    <div className="overflow-y-auto no-scrollbar h-[calc(100vh-100px)] pb-4 ">
      {loading ? (
        <SideNavLoader />
      ) : (
        <div className="relative">
          <div
            className={cn(
              `absolute w-full transition-all duration-300 ${active.isCrm || active.isSetting ? "left-[280px]" : "left-0"
              }`
            )}>
            <Menu
              items={menu}
              setCollapsed={setCollapsed}
              permissions={permissions}
              collapsed={collapsed}
            />
            {Array.isArray(permissions) && permissions.length > 0 && (
              <>
                <div
                  className={cn(
                    "px-4 flex items-center justify-between font-Popins hover:bg-#f3f4f6 py-3 mx-3 cursor-pointer text-gray-600",
                    {
                      "justify-center px-0 text-lg": collapsed,
                    }
                  )}
                  onClick={() => setActive({ isCrm: false, isSetting: true })}>
                  <span
                    className={cn(
                      "flex items-center text-[15px]  text-gray-600 w-full",
                      {
                        "gap-3": !collapsed,
                        "justify-center mr-2": collapsed,
                      }
                    )}>
                    {isRTL ? (
                      <>
                        <IoIosArrowBack />
                        {!collapsed && (
                          <span className="text-[15px] text-gray-600 w-full text-right px-2 font-semibold">
                            {t("navigation.settings")}
                          </span>
                        )}
                        <SettingOutlined />
                      </>
                    ) : (
                      <>
                        <SettingOutlined />
                        {!collapsed && (
                          <span className="text-[15px] text-gray-600 font-semibold">
                            {t("navigation.settings")}
                          </span>
                        )}
                      </>
                    )}
                  </span>
                  {!collapsed && (isRTL ? null : <IoIosArrowForward />)}
                </div>
              </>
            )}
          </div>

          {/* setting menu */}
          <div
            className={cn(
              `absolute w-full text-gray-500 transition-all duration-300 ${active.isSetting ? "left-0" : "-left-[280px]"
              }`
            )}>
            <div
              className={cn(
                "px-4 flex items-center font-medium gap-1 font-Popins bg-#f3f4f6  py-3 cursor-pointer",
                {
                  "flex items-center justify-center text-lg ": collapsed,
                }
              )}
              onClick={() =>
                setActive({ isCrm: false, isSetting: false, isHrm: false })
              }>
              <IoIosArrowBack /> {!collapsed && t("common.backToMenu")}
            </div>
            <hr className=" border-gray-300" />
            <Menu
              items={SettingMenu}
              setCollapsed={setCollapsed}
              permissions={permissions}
              collapsed={collapsed}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default SideNav;
